/**
 * Fetch wrapper that tracks user activity for inactivity timeout
 */

let activityCallback: (() => void) | null = null;

/**
 * Sets the activity callback function
 * This should be called once when the app initializes
 */
export function setActivityCallback(callback: () => void) {
  activityCallback = callback;
}

/**
 * Wrapper around fetch that tracks user activity
 * Use this instead of fetch for all API calls
 */
export async function fetchWithActivity(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  // Reset activity timer on API call
  if (activityCallback) {
    activityCallback();
  }

  // Call the original fetch
  return fetch(input, init);
}

/**
 * Creates a fetch function bound to the activity callback
 * Useful for services that need a custom fetch instance
 */
export function createActivityFetch(resetActivityTimer: () => void) {
  return async function (
    input: RequestInfo | URL,
    init?: RequestInit
  ): Promise<Response> {
    // Reset activity timer on API call
    resetActivityTimer();

    // Call the original fetch
    return fetch(input, init);
  };
}